import App from '@/App.vue'
import { environment } from '@/constants/getEnvironment'
import { i18n } from '@/plugins/i18n'
import router from '@/router'
import '@/style.css'
import hljsVuePlugin from '@highlightjs/vue-plugin'
import * as Sentry from '@sentry/vue'
import HighchartsVue from 'highcharts-vue'
import 'highcharts/modules/map'
import 'highlight.js/lib/common'
import 'highlight.js/styles/stackoverflow-light.css'
import { createPinia } from 'pinia'

// Note: Refreshes the page when a dynamically imported module can't be downloaded.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const pinia = createPinia()

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://2dafb3981dceaccbb895763670951bf0@o4508350128783360.ingest.us.sentry.io/4508370677268480',
  enabled: import.meta.env.PROD,
  environment,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  ignoreErrors: [
    'Failed to fetch dynamically imported module',
    'Non-Error promise rejection captured',
    /^Unable to preload/,
  ],
})

app.use(router)
app.use(pinia)
app.use(HighchartsVue)
app.use(i18n)
app.use(hljsVuePlugin)
app.mount('#app')
